import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import {MatRadioChange} from "@angular/material/radio";

@Component({
    selector: 'app-weave-radio-group',
    templateUrl: './weave-radio-group.component.html',
    styleUrls: ['./weave-radio-group.component.scss'],
    standalone: false
})
export class WeaveRadioGroupComponent implements OnInit {

  @Input() label: string = "";
  @Input() description: string = "";
  @Input() radioList: radio[];
  @Input() required: boolean;
  @Input() data: any = null;
  @Input() showOptionsVertical: boolean = false;
  @Input() showError: boolean = false;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();
  id: string = "";
  message: string = "";
  constructor() { }

  ngOnInit(): void {
    this.id = "weave-radio" + uuidv4();
    if(this.label && this.required){
      this.label += '<span class="required">*</span>';
    }
    this.message = this.label;
    if(this.message.length > 30 || this.message.length === 0) {
      this.message = "This field";
    }
  }

  onChange(changeEvent: MatRadioChange){
    this.showError = false;
    this.changed.emit(changeEvent.value);
  }

}

export interface radio{
  value: any,
  label: string,
}
